import React from "react";
import { Button, Input } from "../components/Form";
import { BiLogInCircle } from "react-icons/bi";
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { login, getAuthStatus, getAuthError } from "../redux/features/authSlice";
import toast from "react-hot-toast";

// Las cuentas se crean desde el backend (`php artisan doctor:crear-usuario`) — no hay
// autoregistro, por eso esta pantalla no tiene link de "crear cuenta".
function Login() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const status = useSelector(getAuthStatus);
  const error = useSelector(getAuthError);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    const res = await dispatch(login(data));
    if (login.fulfilled.match(res)) {
      toast.success("¡Bienvenido!");
      navigate("/");
    } else {
      toast.error(res.payload || "No se pudo iniciar sesión.");
    }
  };

  return (
    <div className="w-full h-screen flex-colo bg-dry">
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="w-full sm:w-2/5 p-8 rounded-2xl mx-auto bg-white flex-colo"
      >
        <img
          src="/images/logomenu.png"
          alt="logo"
          className="w-48 h-16 object-contain mb-6"
        />
        <h2 className="text-2xl font-bold text-center mb-6">Inicio de Sesión</h2>
        <div className="flex flex-col gap-4 w-full mb-6">
          <Input
            label="Email"
            type="email"
            color={true}
            placeholder="doctor@ejemplo.com"
            register={register("email", { required: "El email es obligatorio." })}
            error={errors.email}
          />
          <Input
            label="Contraseña"
            type="password"
            color={true}
            placeholder="*********"
            register={register("password", { required: "La contraseña es obligatoria." })}
            error={errors.password}
          />
          <Link to="/forgot-password" className="text-xs text-subMain self-end">
            ¿Olvidaste tu contraseña?
          </Link>
        </div>
        {error && <p className="text-xs text-red-500 mb-4">{error}</p>}
        <Button
          label={status === "loading" ? "Ingresando..." : "Ingresar"}
          Icon={BiLogInCircle}
          onClick={handleSubmit(onSubmit)}
        />
      </form>
    </div>
  );
}

export default Login;
